import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Card, Link, Container, Typography, Box } from "@mui/material";
import useResponsive from "../hooks/useResponsive";
import { Page } from "../components/Page";
import { LoginForm } from "../sections/auth/login";

const RootStyle = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  width: "100vw",
  background: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
}));

const MainFlex = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: "center",
  width: "100%",
  maxWidth: 900,
  background: "rgba(255,255,255,0.85)",
  boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.18)",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    maxWidth: "95%",
    borderRadius: 24,
    margin: theme.spacing(2),
  },
}));

const PhotoSection = styled("div")(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  background: "#1976d2",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    minHeight: 180,
    maxHeight: 220,
  },
}));

const StyledImg = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  minHeight: 400,
  [theme.breakpoints.down("md")]: {
    minHeight: 180,
    maxHeight: 220,
    borderRadius: "24px 24px 0 0",
  },
}));

const ContentSection = styled("div")(({ theme }) => ({
  flex: 0.9,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(5, 4),
  background: "#fff",
  borderRadius: "0 32px 32px 0",
  [theme.breakpoints.down("md")]: {
    borderRadius: "0 0 24px 24px",
    padding: theme.spacing(4, 2),
  },
}));

export default function Login() {
  const mdUp = useResponsive("up", "md", "xs", "lg");

  return (
    <Page title="Login">
      <RootStyle>
        <MainFlex>
          {/* Only show photo section on desktop */}
          {mdUp && (
            <PhotoSection>
              <StyledImg
                src="/static/images/minh-pham-7pCFUybP_P8-unsplash.jpg"
                alt="login"
              />
            </PhotoSection>
          )}
          <ContentSection>
            <Box
              component="img"
              src="/static/images/newlogo1.png"
              sx={{
                width: "180px",
                height: "auto",
                display: "block",
                margin: "0 auto 8px",
                alignItems: "center",
              }}
            />
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                color: "#333333",
                fontWeight: 600,
                fontSize: 30,
                textAlign: "center",
                mb: 1,
              }}
            >
              Welcome to PMS
            </Typography>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                color: "grey",
                fontSize: 15,
                textAlign: "center",
                mb: 3,
              }}
            >
              Login to your account!
            </Typography>
            <LoginForm />

            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Don’t have an account?{" "}
              <Link variant="subtitle2" component={RouterLink} to="/register">
                Get started
              </Link>
              <br />
              {/* <Link variant="subtitle2" component={RouterLink} to="/adminlogin">
                admin login
              </Link> */}
            </Typography>
          </ContentSection>
        </MainFlex>
      </RootStyle>
    </Page>
  );
}
